import { useState } from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import { SingleTableBoxScene } from "@/shared/components/ui";
import OrdenServicioList from "../../components/table-orden-servicio/TableOrdenServicioCustom";
import {
  EstadosOrdenServicioEnumChoice,
  TipoOrdenServicioEnumChoice,
} from "../../utils/choice.orden-servicio";

const TIPO_OPTIONS = [
  { value: TipoOrdenServicioEnumChoice.TODOS, label: "Todos los tipos" },
  { value: TipoOrdenServicioEnumChoice.TRASLADO, label: "Traslado" },
  { value: TipoOrdenServicioEnumChoice.VISITA, label: "Visita" },
  { value: TipoOrdenServicioEnumChoice.RAZON_SOCIAL, label: "Cambio razón social" },
  { value: TipoOrdenServicioEnumChoice.REPARACION, label: "Reparación" },
];

const ESTADO_OPTIONS = [
  { value: "", label: "Todos los estados" },
  { value: EstadosOrdenServicioEnumChoice.EN_ESPERA, label: "En espera" },
  { value: EstadosOrdenServicioEnumChoice.EN_PROCESO, label: "En proceso" },
  { value: EstadosOrdenServicioEnumChoice.FINALIZADO, label: "Finalizado" },
  { value: EstadosOrdenServicioEnumChoice.PENDIENTE, label: "Pendiente" },
  { value: EstadosOrdenServicioEnumChoice.CANCELADO, label: "Cancelado" },
];

/**
 * Vista GENERAL de órdenes de servicio (todas, no por cliente), con filtros por
 * tipo, estado y rango de fechas — para facilitar la búsqueda sin entrar al
 * contrato. Reusa `OrdenServicioList` (tarjetas + "Ver detalles" enriquecido).
 * Acceso restringido por el módulo OPERACIONES.ORDENES_SERVICIO_GENERAL.
 */
export default function OrdenServicioGeneralPage() {
  const [tipo, setTipo] = useState<string>(TipoOrdenServicioEnumChoice.TODOS);
  const [estado, setEstado] = useState<string>("");
  const [desde, setDesde] = useState<string>("");
  const [hasta, setHasta] = useState<string>("");

  const handleClear = () => {
    setTipo(TipoOrdenServicioEnumChoice.TODOS);
    setEstado("");
    setDesde("");
    setHasta("");
  };

  // Remontar la lista al cambiar filtros para resetear la paginación a la
  // primera página (evita quedar en una página vacía tras filtrar).
  const listKey = `${tipo}|${estado}|${desde}|${hasta}`;

  return (
    <SingleTableBoxScene title={"Órdenes de servicio"} py={2} visibleReport={false}>
      <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2 }}>
        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5, color: "#1565c0" }}>
          Filtros
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              select
              fullWidth
              size="small"
              label="Tipo"
              value={tipo}
              onChange={(e) => setTipo(e.target.value)}
            >
              {TIPO_OPTIONS.map((o) => (
                <MenuItem key={o.value} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              select
              fullWidth
              size="small"
              label="Estado"
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
            >
              {ESTADO_OPTIONS.map((o) => (
                <MenuItem key={o.value || "todos"} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <TextField
              fullWidth
              size="small"
              type="date"
              label="Desde"
              value={desde}
              onChange={(e) => setDesde(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <TextField
              fullWidth
              size="small"
              type="date"
              label="Hasta"
              value={hasta}
              onChange={(e) => setHasta(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Button
              fullWidth
              variant="outlined"
              color="inherit"
              startIcon={<FilterAltOffIcon />}
              onClick={handleClear}
            >
              Limpiar
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Box>
        <OrdenServicioList
          key={listKey}
          tipo_orden_servicio={tipo}
          estado={estado}
          fecha_creacion__gte={desde}
          fecha_creacion__lte={hasta}
        />
      </Box>
    </SingleTableBoxScene>
  );
}
